import { render, staticRenderFns } from "./UiQr.vue?vue&type=template&id=60c899f0"
import script from "./UiQr.vue?vue&type=script&lang=js"
export * from "./UiQr.vue?vue&type=script&lang=js"
import style0 from "./UiQr.vue?vue&type=style&index=0&id=60c899f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports